<ion-app>
  <ion-router-outlet id="content1"></ion-router-outlet>
</ion-app>
